module.exports = __webpack_public_path__ + "img/app/home/img/icon-arrow-lf-press.3257f7c0aefdd53a3c25288978a5ace3.png";